import HttpService from './HttpService';

const ActivitiesApi = HttpService('/api/activities/');
const doPost = (action, data) => ActivitiesApi.post(action, data);
const doGet = (url) => ActivitiesApi.get(url);
const doDelete = (url) => ActivitiesApi.delete(url);

export default {
  getAvailableActivities(activeSiteId) {
    const apiAction = 'GetAvailableActivities';
    const queryString = `activeSiteId=${activeSiteId}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  createActivity(activity) {
    const apiAction = 'CreateActivity';
    return doPost(apiAction, activity);
  },
  updateActivity(activityUpdate) {
    const apiAction = 'UpdateActivity';
    return doPost(apiAction, activityUpdate);
  },
  deleteActivity(id) {
    const apiAction = 'DeleteActivity';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  },
};
